import { useState, useRef } from "react"
// const Typography = React.lazy(() => import('@stardust-ds/react/lib/esm/components/Typography/typography'));

import styles from "./index.module.scss"
import useClickOutside from "../../../hooks/useClickOutside"

function RcmpCardHiddenUsers(props) {
  const { aUsers, color } = props
  const [bIsOpen, fnSetBisOpen] = useState(false)

  const elContainerRef = useRef(null)
  useClickOutside(elContainerRef, () => fnSetBisOpen(false))

  if (!aUsers?.length) return null

  const fnToggleShowUsers = (e) => {
    e.stopPropagation()
    fnSetBisOpen(!bIsOpen)
  }

  return (
    <div ref={elContainerRef} className={styles.containerHiddenUser}>
      <div
        className={styles.showHiddenUser}
        style={{ backgroundColor: color }}
        onClick={fnToggleShowUsers}
      >
        <p>+ {aUsers?.length}</p>
      </div>
      {bIsOpen && (
        <div className={styles.cardHiddenUsers}>
          {aUsers?.map((oUser, nIndex) => (
            <p key={nIndex}>{oUser?.user_cname}</p>
          ))}
        </div>
      )}
    </div>
  )
}

export function RcmpUser(props) {
  const { oUser, color, className, bDisabledTooltip = false, bShowTollTip = true } = props

  const [bOpenToolTip, fnSetBOpenToolTip] = useState(false)

  if (!oUser) return null

  function fnOpenToolTip() {
    if (bDisabledTooltip) return
    fnSetBOpenToolTip(true)
  }

  function fnCloseToolTip() {
    fnSetBOpenToolTip(false)
  }

  const cContainerClasses = `${styles.userIconContainer} ${className ? className : ""}`

  return (
    <div
      className={cContainerClasses}
      onMouseEnter={fnOpenToolTip}
      onMouseLeave={fnCloseToolTip}
    >
      {oUser.user_cavatar ? (
        <div className={styles.userImage}>
          <img src={oUser.user_cavatar} />
        </div>
      ) : (
        <div
          className={styles.userWithouAvatar}
          style={{ backgroundColor: color || "#414a53" }}
        >
          {/*
          <Typography type="l1" color="white">
            {oUser?.user_cname
              ?.split(" ")
              .map((name) => name.charAt(0).toUpperCase())
              .join("")}
          </Typography>
          */}
          {oUser?.user_cname
            ?.split(" ")
            .map((name) => name.charAt(0).toUpperCase())
            .join("")}
        </div>
      )}
      {bOpenToolTip && bShowTollTip && (
        <div className={styles.floatContent}>
          {oUser?.user_cname}
          <div className={styles.arrowContainer} />
        </div>
      )}
    </div>
  )
}

export default function RcmpCardUsers(props) {
  const {
    cLabel,
    aUsers,
    bLarge,
    bSmall,
    className,
    color,
    nShowLimit,
    bShowUserNameWhenThereIsOnlyOne = false,
    bDisabledTooltip = false,
    ...oRest
  } = props
  const nLimitIcons = nShowLimit || 7

  const cClasses = `${styles.cardUsers} ${bLarge ? styles.cardUsersLg : ""} ${bSmall ? styles.cardUsersSm : ""} ${className ? className : ""}`
  const aFirstThreeUsers =
    aUsers?.length > nLimitIcons ? aUsers?.slice(0, nLimitIcons) : aUsers
  const aHiddenUsers = aUsers?.slice(nLimitIcons) || []
  return (
    <div className={cClasses} {...oRest}>
      {cLabel && <p>{cLabel}</p>}
      {aUsers && aUsers?.length > 0 && (
        <div className={styles.usersContainer}>
          {aFirstThreeUsers?.map((oUser, nIndex) => (
            <>
              <RcmpUser key={nIndex} oUser={oUser} color={color} bDisabledTooltip={bDisabledTooltip} />
              {aFirstThreeUsers.length === 1 && bShowUserNameWhenThereIsOnlyOne && (
                <p className={styles.userName}>
                  {oUser?.user_cname}
                </p>
              )}
            </>
          ))}
          <RcmpCardHiddenUsers aUsers={aHiddenUsers} color={color} />
        </div>
      )}
    </div>
  )
}
